import React from "react";
import classnames from "classnames";
import "./FixedHeader.scss";

const FixedHeader = ({ children, className }) => (
  <div className={classnames("header header__fixed", className)}>
    {children}
  </div>
);

export default FixedHeader;
